export const USER_TYPES = {
  EMPLOYEE: "employee",
  ADMIN: "admin",
} as const;
